module.exports = __webpack_public_path__ + "static/media/DSCN2477.eb499503.JPG";